$(function () {
  initSlickSliders();
});

$(window).on('resize', initSlickSliders);

function initSlickSliders() {
  $('.section-collection-list .use-slick-slider-on-desktop .slider, .section-featured-collection .use-slick-slider-on-desktop .product-grid').each(function() {
    let el = $(this);

    if($(window).width() > 989) {
      el.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: true,
        centerMode: true,
        centerPadding: '20px',
        nextArrow: $(el).closest('.use-slick-slider-on-desktop').find('.slick-arrows .arrow-right'),
        prevArrow: $(el).closest('.use-slick-slider-on-desktop').find('.slick-arrows .arrow-left'),

        // the magic
        responsive: [
          {
            breakpoint: 989,
            settings: "unslick" // destroys slick
          }
        ]
      });
    } else {
      el.slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        centerMode: true,
        centerPadding: '20px',
        nextArrow: $(el).closest('.use-slick-slider-on-desktop').find('.slick-arrows .arrow-right'),
        prevArrow: $(el).closest('.use-slick-slider-on-desktop').find('.slick-arrows .arrow-left'),
      });
    }
  })
}

// Article Image Slider
jQuery('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.slider-nav',
  infinite: true
});
jQuery('.slider-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  dots: false,
  centerMode: true,
  focusOnSelect: true,
  infinite: false,
  variableWidth: true
});
//
// // PDP - Product Image Slider
// window.addEventListener('load', () => {
//
//   // For large screen
//   if (window.innerWidth > 990 ) {
//     const element1 = document.querySelectorAll('.product__media-gallery>use-animate');
//     const element2 = document.querySelectorAll('.product__media-gallery>thumbnail-slider');
//
//     if( element1[0] && element2[0] ) {
//       const height1 = element1[0].offsetHeight;
//       const height2 = element2[0].offsetHeight;
//
//       const minHeight = Math.min(height1, height2);
//
//       element1[0].style.height = `${minHeight}px`;
//       element2[0].style.height = `${minHeight}px`;
//     }
//   }
// });

document.addEventListener('DOMContentLoaded', () => {
  // Remove disabled attribute from quantity input when checkbox is checked
  const quantityInputs = document.querySelectorAll('.variation-quantity > [name="Quantity"]');
  quantityInputs.forEach((input) => {
    input.addEventListener('change', (e) => {
      // Remove form attribute from all quantity inputs
      e.target.closest('.product-form__input').querySelectorAll('.quantity .quantity__input').forEach((qtyInput) => {
        qtyInput.removeAttribute('form');
      } );

      // If input is checked
      if (e.target.checked) {
        setTimeout(() => {
          let dataForm = e.target.closest('.variation-quantity').querySelector('.product-form__quantity').getAttribute('data-form');
          let qtyInput = e.target.closest('.variation-quantity').querySelector('.quantity .quantity__input');
          qtyInput.setAttribute('form', dataForm);
          qtyInput.removeAttribute('disabled');
        }, 100);
      }
    });

    // Remove disabled on +- button click
    input.closest('.variation-quantity').querySelectorAll('.quantity__button').forEach((button) => {
      button.addEventListener('click', (e) => {
        // Return if not checked
        if (!input.checked) return;

        // Remove form attribute from all quantity inputs
        e.target.closest('.product-form__input').querySelectorAll('.quantity .quantity__input').forEach((qtyInput) => {
          qtyInput.removeAttribute('form');
        } );

        setTimeout(() => {
          let dataForm = e.target.closest('.variation-quantity').querySelector('.product-form__quantity').getAttribute('data-form');
          let qtyInput = e.target.closest('.variation-quantity').querySelector('.quantity .quantity__input');
          qtyInput.setAttribute('form', dataForm);
          qtyInput.removeAttribute('disabled');
        }, 100);
      });
    } );
  } );

  // Collapsible Description
  const collapsible_items = document.querySelectorAll('.expand-content');

  collapsible_items.forEach(collapsible => {
    collapsible.addEventListener('click', () => {
      // toggle class parent .ellipsis-content class
      collapsible.closest('.ellipsis-content').classList.toggle('expanded');
    });
  });

  if (document.querySelector('[data-close-custom-modal]')) {
    document.querySelectorAll('[data-close-custom-modal]').forEach(button => {
      button.addEventListener('click', () => {
        const modal = document.querySelector('[data-custom-modal]');
        const modalOverlay = document.querySelector('[data-custom-modal-overlay]');
        modal.classList.remove('show-modal');
        modalOverlay.classList.remove('active');
      });
    });
  }

});
